export default {
  title: "Companies"
}
